module.exports = __webpack_public_path__ + "static/media/nS1KO45GLg.1b4c04d2.jpg";